module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVwAAAABCAYAAACScRaxAAAAGElEQVQ4jWP8//8/L8MoGAWjYBSMApoDAI8OAwwv40CqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/commons/hseparator.png
// module id = 256
// module chunks = 0